import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import { domain, baseReportURL } from '@/libs/acl/config';
import { readResolvedIsHesbaClient } from '@/libs/design';
import { isHesbaHost } from '@/libs/appHost';

Vue.mixin({
  data() {
    return {
      perPageOptions: [15, 25, 50, 100, 500],
      perPageOptionsForVoucher: [25, 50, 100, 500],
      baseUrl: domain,
      baseReportURL: baseReportURL,
      currentUrl: window.location.href,
      domain: domain,
    };
  },
  updated: function () {
    if (this.currentBranch) {
      this.fetch();
    }
  },
  computed: {
    ...mapGetters({
      currentLang: 'appConfig/lang',
      isRight: 'appConfig/isRTL',
      branchId: 'app/branchId',
      branches: 'app/branches',
      fiscalYears: 'app/fiscalYears',
      currentYear: 'app/currentYear',
      company: 'app/currentCompany',
      profile: 'auth/profile',
      currentBreakPoint: 'app/currentBreakPoint',
    }),
    currentBranch() {
      // Some global/plugin components can be created without Vuex injected.
      if (!this.$store || !this.$store.getters) return {};
      return this.$store.getters['app/currentBranch'] || {};
    },
    today() {
      return moment().format('YYYY-MM-DD');
    },
    updatedToday() {
      return moment().format('YYYY-MM-DDTHH:mm:ss');
    },
    time() {
      const time = moment().format('HH:mm:ss A');
      return moment(time, ['h:mm:ss A']).format('HH:mm:ss');
    },
    showCostPrice() {
      if (this.profile.isAdmin) return true;
      return this.profile.permissions.includes('showCostPrice');
    },
    showSalesPrice() {
      if (this.profile.isAdmin) return true;
      return this.profile.permissions.includes('showSalesPrice');
    },
    isHesbaClient() {
      const routeName = this.$route && this.$route.name;
      if ((routeName === 'login' || routeName === 'forget-password') && isHesbaHost()) {
        return true;
      }
      const profile = this.profile || {};
      if (profile.userId || profile.userName) {
        return !!profile.isHesbaClient;
      }
      return readResolvedIsHesbaClient();
    },
  },
  methods: {
    isAllowedPeriod(transactionDate) {
      // if !enableClosedPeriod
      if (!this.currentBranch.enableClosedPeriod) {
        return true;
      }
      // if user can skipClosedPeriod
      if (this.$can('skipClosedPeriod')) {
        return true;
      }
      // enableClosedPeriod && user cann't skipClosedPeriod
      const fromDate = new Date(this.currentBranch.closedPeriodFromDate);
      const toDate = new Date(this.currentBranch.closedPeriodToDate);
      const tranDate = new Date(transactionDate);

      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(23, 59, 59, 999);
      tranDate.setHours(0, 0, 0, 0);

      const isInClosedPeriod = tranDate >= fromDate && tranDate <= toDate;
      return !isInClosedPeriod;
    },
    clearIdempotancyKey() {
      sessionStorage.removeItem('current-idempotency-key');
    },
    format(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    formatLocal(value) {
      return moment(value).format('YYYY-MM-DDTHH:mm:ss')
    },
    fetch() {
      if (this.currentBranch.isMaster) {
        fetch(this.currentUrl)
          .then(() => {
            const buttons = document.querySelectorAll('[data-action-type]');
            buttons.forEach((el) => {
              if (
                el.getAttribute('data-action-type') === 'delete' || el.getAttribute('data-action-type') === 'edit'
              ) {
                el.setAttribute('hidden', true);
              } else if (el.getAttribute('data-action-type') === 'preview') {
                el.removeAttribute('hidden');
              } else {
                el.disabled = true;
              }
            });
          })
          .catch(() => { });
      }
    },
    getDayTime(time) {
      return moment(time, ['h:mm:ss']).format('H:mm:ss');
    },
    getTime(time) {
      time = time || moment().format('HH:mm:ss A');
      return moment(time, ['h:mm:ss A']).format('HH:mm:ss');
    },
    isNumber(value) {
      return typeof value === 'number';
    },
    fixTime(d) {
      var x = new Date(d);
      var hoursDiff = x.getHours() - x.getTimezoneOffset() / 60;
      var minutesDiff = (x.getHours() - x.getTimezoneOffset()) % 60;
      x.setHours(hoursDiff);
      x.setMinutes(minutesDiff);
      return moment(x).format('YYYY-MM-DD HH:mm:ss');
    },
    toCamelCase(str) {
      if (!str) return ''
      return str.charAt(0).toLowerCase() + str.slice(1);
    },
    getTimeOrder(time) {
      time = time || moment().format('HH:mm A');
      return moment(time, ['h:mm A']).format('HH:mm');
    },
    convertToLocalTime(dateTime) {
      return moment.utc(dateTime).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    },
    checkForFiscalYearPermForTrans(transDate) {
      // if (this.profile.isAdmin === false && this.profile.permissions.indexOf('viewFiscalYears') === -1 || this.profile.isAdmin) {
      if (this.getDate(transDate) < this.getDate(this.currentYear.startDate)) {
        this.doneAlert({
          type: 'error',
          text: this.$t('youDontHavePermToThisYear'),
        });
        return false;
      }
      if (this.getDate(transDate) > this.getDate(this.currentYear.endDate)) {
        this.doneAlert({
          type: 'error',
          text: this.$t('youDontHavePermToThisYear'),
        });
        return false;
      }
      // }
      return true
    },
    checkForFiscalYearPerm(fromDate, toDate) {
      // if (this.profile.isAdmin === false && this.profile.permissions.indexOf('viewFiscalYears') === -1 || this.profile.isAdmin) {
      if (this.getDate(fromDate) < this.getDate(this.currentYear.startDate)) {
        this.doneAlert({
          type: 'error',
          text: this.$t('youDontHavePermToThisYear'),
        });
        return false;
      }
      if (this.getDate(toDate) > this.getDate(this.currentYear.endDate)) {
        this.doneAlert({
          type: 'error',
          text: this.$t('youDontHavePermToThisYear'),
        });
        return false;
      }
      // }
      return true
    },
    getDate24(date, isTime = false) {
      const format = isTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
      date = date || new Date();
      return moment(date).format(format);
    },
    getDate(date, isTime = false) {
      const format = isTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
      date = date || new Date();
      return moment(date).format(format);
    },
    getShortDate(date, isTime = false) {
      const format = isTime ? 'YYYY-MM-DD HH:mm:ss' : 'MM-DD';
      date = date || new Date();
      return moment(date).format(format);
    },
    getUtcDate(date) {
      date = date || new Date();
      return moment.utc(date).format('YYYY-MM-DD HH:mm:ss');
    },
    getUtcTime(date) {
      date = date || new Date();
      return moment.utc(date).format('HH:mm:ss');
    },
    roundTo(n, digits) {
      if (digits === undefined) {
        digits = 0;
      }
      var multiplicator = Math.pow(10, digits);
      n = n ? parseFloat((n * multiplicator).toFixed(11)) : 0;
      return (Math.round(n) / multiplicator).toFixed(this.currentBranch.decimalDigits);
    },
    camelize(str) {
      return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      }).replace(/\s+/g, '');
    },
    wraps(str) {
      const abbreviatedLabel = str && str.length > 38 ? `${str.substring(0, 38)}...` : str || '';
      return abbreviatedLabel;
    },
    fraction(number, roundTo = this.currentBranch.decimalDigits) {
      number = this.roundTo(number, roundTo) || 0;
      return Number(parseFloat(number).toFixed(roundTo)) || 0;
    },
    getMonthName(month) {
      const d = new Date();
      d.setMonth(month - 1);
      const monthName = d.toLocaleString('default', { month: 'short' });
      return monthName;
    },
    a2hex(str) {
      const encoder = new TextEncoder(); // UTF-8
      const bytes = encoder.encode(str);

      return Array.from(bytes)
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) && 0xFF;
      return buf;
    },
    d2h(d) { return d > 16 ? (+d).toString(16) : `0${(+d).toString(16)}` },
    hex_to_ascii(str1) {
      const hex = str1.toString();
      this.str = '';
      for (let n = 0; n < hex.length; n += 2) {
        this.str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
      }
      return this.str;
    },
    truncateNum(number) {
      return number.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
    },
    Export2Word(element, filename = '') {
      var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
      var postHtml = '</body></html>';
      var html = preHtml + document.getElementById(element).innerHTML + postHtml;
      var blob = new Blob(['\ufeff', html], {
        type: 'application/msword',
      });
      // Specify link url
      var url = `data:application/vnd.ms-word;charset=utf-8,${encodeURIComponent(html)}`;
      var downloadLink = document.createElement('a');
      // Specify file name
      filename = filename ? `${filename} + '.doc'` : 'document.doc';
      // Create download link element
      // var downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;
        // Setting the file name
        downloadLink.download = filename;
        // triggering the function
        downloadLink.click();
      }
      document.body.removeChild(downloadLink);
    },
    getFilterObj(obj) {
      return Object.entries(obj).reduce((query, item) => {
        if ([null, ''].indexOf(item[1]) > -1) return query;
        if (query) query += '&';
        query += `${item[0]}=${item[1]}`;
        return query;
      }, '');
    },
    validateDiscount(v, item) {
      if (v < 0) {
        item.discountValue = 0;
      }
    },
    orderQuery(sortBy, sortDesc) {
      if (sortBy) return `${sortBy} ${sortDesc ? 'DESC' : 'ASC'}`;
      return '';
    },
    ...mapActions({
      get: 'app/get',
      getAll: 'app/getAll',
      create: 'app/create',
      update: 'app/update',
      delete: 'app/delete',
    }),
    doneAlert({ type, title, text, timer = 2000 }) {
      type = type || 'success';
      this.$swal({
        icon: type,
        title: title || this.$t(type),
        text: text,
        timer: timer,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      });
    },
    $can(permission) {
      if (this.profile.isAdmin) return this.profile.isAdmin;
      return (
        !this.profile.permissions || this.profile.permissions.indexOf(permission) > -1
      );
    },
    // $can(permission) {
    //   if (this.profile.isAdmin) return true;

    //   if (!this.profile.permissions) return false;

    //   return this.profile.permissions.some(
    //     p => p.toLowerCase() === permission.toLowerCase()
    //   );
    // },
    confirmAction(data, confirmCallback, cancelCallback) {
      const {
        title,
        text,
        html,
        type,
        confirmText,
        cancelText
      } = data;

      this.$swal({
        title: title || this.$t('Are you sure?'),
        html: html || text,
        icon: type || 'warning',
        showCancelButton: true,
        confirmButtonText: confirmText || this.$t('Yes!'),
        cancelButtonText: cancelText || this.$t('Cancel'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          if (confirmCallback) confirmCallback();
        } else if (result.isDismissed) {
          if (cancelCallback) cancelCallback();
        }
      })
    },
    confirmActionAdd(data, callbackFn) {
      const {
        title,
        text,
        type,
        confirmText,
        cancelText
      } = data;
      this.$swal(
        {
          title: title || this.$t('codeIsNotExsist'),
          text: text,
          icon: type || 'warning',
          showCancelButton: true,
          confirmButtonText: confirmText || this.$t('Yes!'),
          cancelButtonText: cancelText || this.$t('Cancel'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }
      )
        .then(
          (result) => {
            if (result.value) {
              if (callbackFn) callbackFn();
            }
          }
        );
    },
    confirmActivate(data, callbackFn) {
      const {
        title, text, type, confirmText, cancelText
      } = data;
      this.$swal({
        title: title || this.$t('Are you sure?'),
        text: text,
        icon: type || 'warning',
        showCancelButton: true,
        confirmButtonText: confirmText || this.$t('Yes!'),
        cancelButtonText: cancelText || this.$t('Cancel'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          if (callbackFn) callbackFn();
        }
      });
    },
    confirmActionTechSupport(data, callbackFn) {
      const {
        title,
        text,
        type,
        confirmText,
        cancelText
      } = data;
      this.$swal(
        {
          title: title,
          text: text,
          icon: type || 'warning',
          showCancelButton: true,
          confirmButtonText: confirmText || this.$t('Yes!'),
          cancelButtonText: cancelText || this.$t('Cancel'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }
      )
        .then(
          (result) => {
            if (result.value) {
              if (callbackFn) callbackFn();
            }
          }
        );
    },
    getWhatsappTemplate(phone, dealerName, invoiceCode, invoiceNet, invoiceUrl, companyName, companyPhone) {
      return {
        'path': 'message/template',
        'params': {
          'phone': `${phone}`,
          'template': 'sendinvoice',
          'language': {
            'policy': 'deterministic',
            'code': 'ar'
          },
          'namespace': 'e881f9d1_3b9d_4fa6_bcfc_f892ca0e2096',
          'params': [{
            'type': 'header',
            'parameters': [{
              'type': 'document',
              'document': {
                'link': `${invoiceUrl}`
              }
            }]
          },
          {
            'type': 'body',
            'parameters': [{
              'type': 'text',
              'text': `${dealerName}`
            },
            {
              'type': 'text',
              'text': `${invoiceCode}`
            },
            {
              'type': 'text',
              'text': `${invoiceNet}`
            },
            {
              'type': 'text',
              'text': `${companyName}`
            },
            {
              'type': 'text',
              'text': `${companyPhone}`
            }]
          }]
        }
      }
    }
  },
});
